import { Button, Card } from 'react-daisyui'
import { useAuth } from "react-oidc-context";

const Login = () => {
  const auth = useAuth();
    return (
        <Card side="lg">
          <Card.Image
            src="/lf-update-150x150.jpg"
            alt="Life-Fit Logo"
          />
          <Card.Body>
            <Card.Title tag="h2">Login Required</Card.Title>
            <p>Please login. Contact XXXXXXXXXXXXXXXXXX to become a contributor.</p>
            <Card.Actions className="justify-end">
              <Button color="primary" onClick={()=>auth.signinRedirect({redirect_uri: `${window.location.origin}`})}>Login with SSO</Button>
            </Card.Actions>
          </Card.Body>
        </Card>
      );
};

export default Login;